/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MissionEditorSelectorKind {
    None = '0',
    Editor = 1,
    PrioritySearch = 2,
}
